"use client";

import type React from "react";
import { useEffect, useState } from "react";
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useLocation, useParams } from "react-router";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  ListItem,
  ListItemText,
  Button,
  Collapse,
  Box,
  Divider,
  IconButton,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  FormControl,
  RadioGroup,
  MenuItem,
  InputLabel,
  FormControlLabel,
  Radio,
  Select,
  OutlinedInput,
  ListSubheader,
  TableCell,
  Tooltip,
  Chip,
  TableBody,
  TableHead,
  Table,
  TableRow,
  InputAdornment,
  Paper,
  Stack,
  Avatar,
  Fab,
  Zoom,
  CardHeader,
  Alert,
  Skeleton,
  Pagination,
  Breadcrumbs,
  Tabs,
  Tab,
  alpha,
} from "@mui/material";
import {
  ExpandMore,
  ExpandLess,
  Description,
  Assessment,
  ArrowBack,
  EditNotifications,
  Add,
  PlayCircleOutline,
  Quiz,
  School,
  BookmarkBorder,
  Error,
  Home,
  Folder,
  NavigateNext,
} from "@mui/icons-material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { baseUrl, config, requestID } from "../../../common/utils";
import axios from "axios";
import { Link } from "react-router-dom";

interface LessonFile {
  id: string;
  name: string;
  url: string;
  activityType?: string;
  activityID?: string;
}

interface CBT {
  id: string;
  title: string;
  questions: number;
}

interface Lesson {
  lessonID: string;
  name: string;
  description?: string;
  lessonFiles: LessonFile[];
  quizzes: { quizzID: string; name: string }[];
}

interface Module {
  secID: string;
  name: string;
  lessons: Lesson[];
}

interface Course {
  cosID: string;
  name: string;
  description?: string;
  sections: Module[];
}

interface ActivitySection {
  section: { secID: string; name: string };
  lessonFiles: { activityID: string; name: string }[];
}

interface CBTQuestion {
  id: string;
  question: string;
  option1: string;
  option2: string;
  option3: string;
  option4: string;
  option5: string;
  ans: string;
}

const ModulePage: React.FC = () => {
  const { name } = useParams<{ name: string }>();
  const [expandedLesson, setExpandedLesson] = useState<string | null>(null);
  const theme = useTheme();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const idFromQuery = queryParams.get("id");
  const dataFromState = location.state?.["role"] || {};

  const courseId = dataFromState.cosID || idFromQuery;
   const data = location.state?.["role"] || {};

  console.log(idFromQuery);
  console.log(dataFromState);
  console.log(courseId);
  const [status, setStatus] = useState({
    loading: false,
    error: false,
    errorMessage: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [courseData, setCourseData] = useState<Course[]>([]);
  const [showModuleModal, setShowModuleModal] = useState(false);
  const [newModuleTitle, setNewModuleTitle] = useState("");
  const [showLessonTitleModal, setShowLessonTitleModal] = useState<
    string | null
  >(null);
  const [newLessonTitle, setNewLessonTitle] = useState("");
  const [showLessonFileModal, setShowLessonFileModal] = useState<string | null>(
    null
  );
  const [newFileTitle, setNewFileTitle] = useState("");
  const [mediaType, setMediaType] = useState<"file" | "link">("file");
  const [fileUpload, setFileUpload] = useState<File | null>(null);
  const [selectedItems, setSelectedItems] = useState<ActivitySection[]>([]);
  const [newFileMediaType, setNewFileMediaType] = useState<
    "video" | "document" | "link"
  >("link");
  const [activityCompletion, setActivityCompletion] = useState<number>(0);
  const [newFileMediaLink, setNewFileMediaLink] = useState("");
  const [selectedFileId, setSelectedFileId] = useState<string>("0");
  const [completionConstraint, setCompletionConstraint] = useState<number>(0);
  const [showCBTQuestionsModal, setShowCBTQuestionsModal] = useState<
    string | null
  >(null);
  const [newQuestionText, setNewQuestionText] = useState("");
  const [newQuestionOptions, setNewQuestionOptions] = useState<string[]>([
    "",
    "",
    "",
    "",
    "",
  ]);
  const [newQuestionCorrectAnswer, setNewQuestionCorrectAnswer] =
    useState<number>(0);
  const [cbtQuestions, setCBTQuestions] = useState<CBTQuestion[]>([]);
  const [showCBTTitleModal, setShowCBTTitleModal] = useState<string | null>(
    null
  );
  const [newCBTTitle, setNewCBTTitle] = useState("");
  const [passGrade, setPassGrade] = useState("");
  const [failRemark, setFailRemark] = useState("");
  const [passRemark, setPassRemark] = useState("");
  const [questionGrade, setQuestionGrade] = useState("");
  const [quizTime, setQuizTime] = useState("");
  const [unlimitedExam, setUnlimitedExam] = useState<string>("0");
  const [quizType, setQuizType] = useState<"lesson" | "section">("lesson");
  const [cbtConstraint, setCbtConstraint] = useState<string>("0");

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [activeTab, setActiveTab] = useState(0);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFileUpload(event.target.files[0]);
    } else {
      setFileUpload(null);
    }
  };

  const handleLinkChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewFileMediaLink(e.target.value);
  };

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedFileId(event.target.value as string);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    setCurrentPage(1); // Reset to first page when changing tabs
  };

  // Pagination logic
  const paginatedModules =
    courseData[0]?.sections?.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    ) || [];

  const totalPages = Math.ceil(
    (courseData[0]?.sections?.length || 0) / itemsPerPage
  );

  useEffect(() => {
    if (courseId) {
      getAllModule();
      getActivityCompletionData(courseId);
    }
  }, [courseId]);

  const getAllModule = async () => {
    setStatus({ loading: true, error: false, errorMessage: "" });

    try {
      if (!courseId) throw new Error("Course ID is missing");

      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("cosID", courseId.toString());

      const response = await axios.post(
        baseUrl() + "courses/getFullCourseStructureByCosID",

        formData,
        config
      );

      setCourseData(response.data.data || []);
      console.log("module", response.data.data || []);
      setStatus({ loading: false, error: false, errorMessage: "" });
    } catch (error: any) {
      console.error("API call failed:", error);
      setStatus({
        loading: false,
        error: true,
        errorMessage: error.message || "Failed to fetch course data",
      });
    }
  };

  const getQuizQuestions = async (quizzID: string) => {
    setIsLoading(true);
    setStatus({ loading: true, error: false, errorMessage: "" });

    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("quizzID", quizzID);

      const response = await axios.post(
        baseUrl() + "courses/getQuestionsByQuizzID",
        formData,
        config
      );

      console.log("Quiz Questions Response:", response);

      const questions = response.data.data || [];
      console.log("questions", questions);

      setCBTQuestions(questions);
      setStatus({ loading: false, error: false, errorMessage: "" });
    } catch (error: any) {
      console.error("Error fetching questions:", error);
      setStatus({
        loading: false,
        error: true,
        errorMessage: error.message || "Failed to fetch questions",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddModule = () => {
    setShowModuleModal(true);
  };

  const handleAddOrEditModule = async () => {
    if (!newModuleTitle.trim()) {
      setStatus({
        loading: false,
        error: true,
        errorMessage: "Module title is required",
      });
      return;
    }

    setIsLoading(true);
    setStatus({ loading: true, error: false, errorMessage: "" });

    try {
      if (!courseId) return;
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("cosID", courseId);
      formData.append("name", newModuleTitle.trim());
      formData.append("status", "1");

      await axios.post(baseUrl() + "courses/addSection", formData, config);
      await getAllModule();
    } catch (error: any) {
      console.error("Error adding module:", error);
      setStatus({
        loading: false,
        error: true,
        errorMessage: error.message || "Failed to add module",
      });
    } finally {
      setIsLoading(false);
      setNewModuleTitle("");
      setShowModuleModal(false);
    }
  };

  const handleAddLesson = (moduleId: string) => {
    setShowLessonTitleModal(moduleId);
  };

  const handleAddOrEditLessonTitle = async (secID: string) => {
    if (!newLessonTitle.trim()) {
      setStatus({
        loading: false,
        error: true,
        errorMessage: "Lesson title is required",
      });
      return;
    }

    setIsLoading(true);
    setStatus({ loading: true, error: false, errorMessage: "" });

    try {
      if (!courseId) return;
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("cosID", courseId);
      formData.append("secID", secID);
      formData.append("name", newLessonTitle.trim());

      await axios.post(baseUrl() + "courses/addLesson", formData, config);
      await getAllModule();
    } catch (error: any) {
      console.error("Error while adding/editing lesson:", error);
      setStatus({
        loading: false,
        error: true,
        errorMessage: error.message || "Failed to add lesson",
      });
    } finally {
      setIsLoading(false);
      setNewLessonTitle("");
      setShowLessonTitleModal(null);
    }
  };

  const handleToggleLesson = (lessonId: string) => {
    setExpandedLesson(expandedLesson === lessonId ? null : lessonId);
  };

  const handleAddFile = (lessonId: string) => {
    setShowLessonFileModal(lessonId);
  };

  async function getActivityCompletionData(cosID: number | string) {
    if (!cosID) return;
    setIsLoading(true);
    setStatus({ loading: true, error: false, errorMessage: "" });

    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("cosID", cosID.toString());

      const response = await axios.post(
        baseUrl() + "courses/getSectionsData",
        formData,
        config
      );
      setSelectedItems(response.data.data || []);
    } catch (error: any) {
      console.error("API call failed:", error);
      setStatus({
        loading: false,
        error: true,
        errorMessage:
          error.message || "Failed to fetch activity completion data",
      });
    } finally {
      setIsLoading(false);
      setStatus({ loading: false, error: false, errorMessage: "" });
    }
  }

  const handleAddOrEditLessonFile = async (lessonID: string) => {
    if (!newFileTitle.trim()) {
      setStatus({
        loading: false,
        error: true,
        errorMessage: "File title is required",
      });
      return;
    }

    if (mediaType === "file" && !fileUpload) {
      setStatus({
        loading: false,
        error: true,
        errorMessage: "Please upload a file",
      });
      return;
    }

    if (mediaType === "link" && !newFileMediaLink.trim()) {
      setStatus({
        loading: false,
        error: true,
        errorMessage: "Media link is required",
      });
      return;
    }

    setIsLoading(true);
    setStatus({ loading: true, error: false, errorMessage: "" });

    try {
      if (!courseId) return;
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("lessonID", lessonID);
      formData.append("cosID", courseId);
      const module = courseData[0]?.sections?.find((m) =>
        m.lessons.some((l) => l.lessonID === lessonID)
      );
      formData.append("secID", module?.secID || "");
      formData.append("name", newFileTitle.trim());
      formData.append("constID", completionConstraint.toString());
      formData.append(
        "activityID",
        selectedFileId === "0" ? "" : selectedFileId
      );
      formData.append("mediaType", newFileMediaType);
      formData.append("link", newFileMediaLink.trim());

      if (fileUpload && mediaType === "file") {
        formData.append("image", fileUpload);
      }

      const response = await axios.post(
        baseUrl() + "courses/addLessonFile",
        formData,
        config
      );

      console.log(response);

      await getAllModule();
    } catch (error: any) {
      console.error("Error while adding/editing lesson file:", error);
      setStatus({
        loading: false,
        error: true,
        errorMessage: error.message || "Failed to add lesson file",
      });
    } finally {
      setIsLoading(false);
      setNewFileTitle("");
      setNewFileMediaLink("");
      setNewFileMediaType("link");
      setFileUpload(null);
      setSelectedFileId("0");
      setCompletionConstraint(0);
      setShowLessonFileModal(null);
    }
  };

  const handleShowTitle = (lessonId: string) => {
    setShowCBTTitleModal(lessonId);
  };

  const handleAddCBTTitle = async (lessonID: string) => {
    if (!newCBTTitle.trim()) {
      setStatus({
        loading: false,
        error: true,
        errorMessage: "CBT title is required",
      });
      return;
    }

    if (
      !passGrade.trim() ||
      isNaN(Number(passGrade)) ||
      Number(passGrade) < 0 ||
      Number(passGrade) > 100
    ) {
      setStatus({
        loading: false,
        error: true,
        errorMessage: "Valid passing grade (0-100%) is required",
      });
      return;
    }

    if (
      !questionGrade.trim() ||
      isNaN(Number(questionGrade)) ||
      Number(questionGrade) <= 0
    ) {
      setStatus({
        loading: false,
        error: true,
        errorMessage: "Valid question grade (greater than 0) is required",
      });
      return;
    }

    if (!quizTime.trim() || isNaN(Number(quizTime)) || Number(quizTime) <= 0) {
      setStatus({
        loading: false,
        error: true,
        errorMessage:
          "Valid quiz time (in minutes, greater than 0) is required",
      });
      return;
    }

    setIsLoading(true);
    setStatus({ loading: true, error: false, errorMessage: "" });

    try {
      if (!courseId) return;
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("cosID", courseId);
      const module = courseData[0]?.sections?.find((m) =>
        m.lessons.some((l) => l.lessonID === lessonID)
      );
      formData.append("secID", module?.secID || "");
      formData.append("lessonID", lessonID);
      formData.append(
        "activityID",
        selectedFileId === "0" ? "" : selectedFileId
      );
      formData.append("quizzName", newCBTTitle.trim());
      formData.append("passGrade", passGrade.trim());
      formData.append("failRemark", failRemark.trim());
      formData.append("passRemark", passRemark.trim());
      formData.append("questionGrade", questionGrade.trim());
      formData.append("quizzTime", quizTime.trim());
      formData.append("unlimitedExam", unlimitedExam);
      formData.append("constID", cbtConstraint);
      formData.append("quizzType", quizType);

      const response = await axios.post(
        baseUrl() + "courses/addQuizz",
        formData,
        config
      );

      console.log(response);

      await getAllModule();
    } catch (error: any) {
      console.error("Error while adding CBT:", error);
      setStatus({
        loading: false,
        error: true,
        errorMessage: error.message || "Failed to add CBT",
      });
    } finally {
      setIsLoading(false);
      setNewCBTTitle("");
      setPassGrade("");
      setFailRemark("");
      setPassRemark("");
      setQuestionGrade("");
      setQuizTime("");
      setUnlimitedExam("0");
      setCbtConstraint("0");
      setQuizType("lesson");
      setSelectedFileId("0");
      setShowCBTTitleModal(null);
    }
  };

  const handleShowQuestion = async (lessonId: string) => {
    setShowCBTQuestionsModal(lessonId);
    setNewQuestionText("");
    setNewQuestionOptions(["", "", "", "", ""]);
    setNewQuestionCorrectAnswer(0);

    // Find the quiz ID for the lesson
    const module = courseData[0]?.sections?.find((m) =>
      m.lessons.some((l) => l.lessonID === lessonId)
    );
    const lesson = module?.lessons.find((l) => l.lessonID === lessonId);
    const quizzID = lesson?.quizzes?.[0]?.quizzID;

    // console.log("lesson", lesson?.quizzes?.[0]?.quizzID);
    console.log("lesson", lesson?.quizzes[0]?.questions);

    if (quizzID) {
      await getQuizQuestions(quizzID);
    } else {
      setCBTQuestions([]);
      setStatus({
        loading: false,
        error: true,
        errorMessage: "No quiz found for this lesson",
      });
    }
  };

  const handleAddQuestion = async (lessonID: string) => {
    if (!newQuestionText.trim()) {
      setStatus({
        loading: false,
        error: true,
        errorMessage: "Question text is required",
      });
      return;
    }

    if (newQuestionOptions.some((opt) => !opt.trim())) {
      setStatus({
        loading: false,
        error: true,
        errorMessage: "All options must be filled",
      });
      return;
    }

    setIsLoading(true);
    setStatus({ loading: true, error: false, errorMessage: "" });

    try {
      if (!courseId) return;
      const module = courseData[0]?.sections?.find((m) =>
        m.lessons.some((l) => l.lessonID === lessonID)
      );
      const lesson = module?.lessons.find((l) => l.lessonID === lessonID);
      const quizzID = lesson?.quizzes?.[0]?.quizzID;

      if (!quizzID) {
        throw new Error("No quiz found for this lesson");
      }

      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("cosID", courseId);
      formData.append("quizzID", quizzID);
      formData.append("question", newQuestionText.trim());
      formData.append("a", newQuestionOptions[0].trim());
      formData.append("b", newQuestionOptions[1].trim());
      formData.append("c", newQuestionOptions[2].trim());
      formData.append("d", newQuestionOptions[3].trim());
      formData.append("e", newQuestionOptions[4].trim());
      formData.append("ans", newQuestionCorrectAnswer.toString());

      const response = await axios.post(
        baseUrl() + "courses/addQuestion",
        formData,
        config
      );

      console.log(response);

      const newQuestion = {
        id: response.data.data?.id || Date.now().toString(),
        question: newQuestionText.trim(),
        option1: newQuestionOptions[0].trim(),
        option2: newQuestionOptions[1].trim(),
        option3: newQuestionOptions[2].trim(),
        option4: newQuestionOptions[3].trim(),
        option5: newQuestionOptions[4].trim(),
        ans: newQuestionCorrectAnswer.toString(),
      };

      setCBTQuestions((prev) => [...prev, newQuestion]);
      setNewQuestionText("");
      setNewQuestionOptions(["", "", "", "", ""]);
      setNewQuestionCorrectAnswer(0);
      await getQuizQuestions(quizzID);
    } catch (error: any) {
      console.error("Error while adding question:", error);
      setStatus({
        loading: false,
        error: true,
        errorMessage: error.message || "Failed to add question",
      });
    } finally {
      setIsLoading(false);
      setStatus({ loading: false, error: false, errorMessage: "" });
    }
  };

  return (
    <IonPage className="pushDown"> 
      <IonHeader>
        <IonToolbar
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          }}
        >
          <IonButtons slot="start">
            <IonMenuButton style={{ color: "white" }} />
          </IonButtons>
          <IonTitle style={{ fontWeight: 600, color: "white" }}>
            {data?.name || "Learning Modules"}
          </IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent
        fullscreen
        style={{
          background:
            theme.palette.mode === "dark"
              ? "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)"
              : "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        }}
      >
        <Container maxWidth="xl" sx={{ py: 3 }}>
          {/* Breadcrumbs */}
          {/* <Breadcrumbs
            separator={<NavigateNext fontSize="small" />}
            aria-label="breadcrumb"
            sx={{ mb: 3 }}
          >
            <Link
              to="/"
              style={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Home sx={{ mr: 0.5, fontSize: 20 }} />
           Home
            </Link>
            <Link
              to="/create"
              style={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Folder sx={{ mr: 0.5, fontSize: 20 }} />
              Courses
            </Link>
            <Typography
              color="text.primary"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <School sx={{ mr: 0.5, fontSize: 20 }} />
              {courseData[0]?.name || "Learning Modules"}
            </Typography>
          </Breadcrumbs> */}

          {/* Header Section */}
          <Paper
            elevation={0}
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: 4,
              p: 4,
              mb: 4,
              color: "white",
              position: "relative",
              overflow: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                right: 0,
                width: "200px",
                height: "200px",
                background: "rgba(255,255,255,0.1)",
                borderRadius: "50%",
                transform: "translate(50%, -50%)",
              },
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box sx={{ zIndex: 1 }}>
                <Link to="/create" style={{ textDecoration: "none" }}>
                  <Button
                    variant="outlined"
                    startIcon={<ArrowBack />}
                    sx={{
                      borderColor: "rgba(255,255,255,0.3)",
                      color: "white",
                      mb: 2,
                      "&:hover": {
                        borderColor: "white",
                        background: "rgba(255,255,255,0.1)",
                      },
                    }}
                  >
                    Back to Courses
                  </Button>
                </Link>
                <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
                  {courseData[0]?.name || "Learning Modules"}
                </Typography>
                <Typography variant="h6" sx={{ opacity: 0.9, fontWeight: 400 }}>
                  {courseData[0]?.description ||
                    "Manage your course content and assessments"}
                </Typography>
              </Box>
              <Avatar
                sx={{
                  width: 80,
                  height: 80,
                  bgcolor: "rgba(255,255,255,0.2)",
                  zIndex: 1,
                }}
              >
                <School sx={{ fontSize: 40 }} />
              </Avatar>
            </Stack>
          </Paper>

          {/* Tabs for different views */}
          {/* <Paper sx={{ mb: 3, borderRadius: 3, overflow: "hidden" }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              sx={{
                "& .MuiTab-root": {
                  fontSize: "1rem",
                  fontWeight: 600,
                  py: 2,
                },
              }}
            >
              <Tab label="Modules" />
              <Tab label="Analytics" />
              <Tab label="Settings" />
            </Tabs>
          </Paper> */}

          {status.loading && (
            <Paper sx={{ p: 3, mb: 3, borderRadius: 3 }}>
              <Stack spacing={2}>
                <Skeleton variant="rectangular" height={60} />
                <Skeleton variant="rectangular" height={120} />
                <Skeleton variant="rectangular" height={80} />
              </Stack>
            </Paper>
          )}

          {status.error && (
            <Alert
              severity="error"
              sx={{ mb: 3, borderRadius: 3 }}
              icon={<Error />}
            >
              {status.errorMessage}
            </Alert>
          )}

          {!courseData[0]?.sections?.length && !status.loading && (
            <Paper
              sx={{
                p: 6,
                textAlign: "center",
                borderRadius: 4,
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(135deg, #2d3748 0%, #4a5568 100%)"
                    : "linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)",
              }}
            >
              <School sx={{ fontSize: 80, color: "text.secondary", mb: 2 }} />
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                No modules available yet
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                Start building your course by creating your first module
              </Typography>
              <Button
                variant="contained"
                size="large"
                startIcon={<Add />}
                onClick={handleAddModule}
                sx={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: 3,
                  px: 4,
                  py: 1.5,
                }}
              >
                Create First Module
              </Button>
            </Paper>
          )}

          {/* Module Grid with Pagination Controls */}
          {courseData[0]?.sections?.length > 0 && (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  Course Modules ({courseData[0]?.sections?.length || 0})
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <FormControl size="small" sx={{ minWidth: 120 }}>
                    <InputLabel>Per Page</InputLabel>
                    <Select
                      value={itemsPerPage}
                      label="Per Page"
                      onChange={(e) => {
                        setItemsPerPage(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                      sx={{ borderRadius: 2 }}
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                    </Select>
                  </FormControl>

                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={(event, value) => setCurrentPage(value)}
                    color="primary"
                    size="large"
                    showFirstButton
                    showLastButton
                    sx={{
                      "& .MuiPaginationItem-root": {
                        borderRadius: 2,
                        fontWeight: 600,
                      },
                    }}
                  />
                </Box>
              </Box>

              <Grid container spacing={3}>
                {paginatedModules.map((module, moduleIndex) => {
                  const globalIndex =
                    (currentPage - 1) * itemsPerPage + moduleIndex;
                  return (
                    <Grid item xs={12} key={module.secID}>
                      <Card
                        elevation={0}
                        sx={{
                          borderRadius: 3,
                          background:
                            theme.palette.mode === "dark"
                              ? "linear-gradient(135deg, #2d3748 0%, #4a5568 100%)"
                              : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                          border: `1px solid ${theme.palette.divider}`,
                          transition: "all 0.3s ease",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: theme.shadows[8],
                          },
                        }}
                      >
                        <CardHeader
                          avatar={
                            <Avatar
                              sx={{
                                background:
                                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                width: 56,
                                height: 56,
                              }}
                            >
                              <BookmarkBorder />
                            </Avatar>
                          }
                          title={
                            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                             {module.name}
                            </Typography>
                          }
                          subheader={
                            <Typography variant="body2" color="text.secondary">
                              {module.lessons?.length || 0} lessons •
                              Interactive content
                            </Typography>
                          }
                          action={
                            <Button
                              variant="contained"
                              startIcon={<Add />}
                              onClick={() => handleAddLesson(module.secID)}
                              disabled={isLoading}
                              sx={{
                                background:
                                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                borderRadius: 3,
                              }}
                            >
                              Add Lesson
                            </Button>
                          }
                        />

                        <CardContent sx={{ pt: 0 }}>
                          {!module.lessons?.length && (
                            <Alert
                              severity="info"
                              sx={{ borderRadius: 2, mb: 2 }}
                            >
                              No lessons available. Click "Add Lesson" to create
                              your first lesson.
                            </Alert>
                          )}

                          <Stack spacing={2}>
                            {module.lessons.map((lesson, lessonIndex) => (
                              <Paper
                                key={lesson.lessonID}
                                elevation={0}
                                sx={{
                                  border: `1px solid ${theme.palette.divider}`,
                                  borderRadius: 3,
                                  overflow: "hidden",
                                  transition: "all 0.2s ease",
                                }}
                              >
                                <ListItem
                                  sx={{
                                    background:
                                      theme.palette.mode === "dark"
                                        ? "rgba(255,255,255,0.02)"
                                        : "rgba(0,0,0,0.02)",
                                    "&:hover": {
                                      background:
                                        theme.palette.mode === "dark"
                                          ? "rgba(255,255,255,0.05)"
                                          : "rgba(0,0,0,0.05)",
                                    },
                                  }}
                                >
                                  <Avatar
                                    sx={{
                                      mr: 2,
                                      background:
                                        "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                                      width: 40,
                                      height: 40,
                                    }}
                                  >
                                    <PlayCircleOutline />
                                  </Avatar>
                                  <ListItemText
                                    primary={
                                      <Typography
                                        variant="h6"
                                        sx={{ fontWeight: 600 }}
                                      >
                                        {/* Lesson {lessonIndex + 1}: */}
                                         {lesson.name}
                                      </Typography>
                                    }
                                    secondary={
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        {lesson.lessonFiles?.length || 0} files
                                        • {lesson.quizzes?.length || 0}{" "}
                                        assessments
                                      </Typography>
                                    }
                                  />
                                  <Stack direction="row" spacing={1}>
                                    <Button
                                      variant="outlined"
                                      size="small"
                                      startIcon={<Add />}
                                      onClick={() =>
                                        handleAddFile(lesson.lessonID)
                                      }
                                      disabled={isLoading}
                                      sx={{ borderRadius: 2 }}
                                    >
                                      Add File
                                    </Button>
                                    <IconButton
                                      onClick={() =>
                                        handleToggleLesson(lesson.lessonID)
                                      }
                                      sx={{
                                        background:
                                          theme.palette.mode === "dark"
                                            ? "rgba(255,255,255,0.1)"
                                            : "rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      {expandedLesson === lesson.lessonID ? (
                                        <ExpandLess />
                                      ) : (
                                        <ExpandMore />
                                      )}
                                    </IconButton>
                                  </Stack>
                                </ListItem>

                                <Collapse
                                  in={expandedLesson === lesson.lessonID}
                                >
                                  <Box
                                    sx={{
                                      p: 3,
                                      borderTop: `1px solid ${theme.palette.divider}`,
                                    }}
                                  >
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        mb: 2,
                                        fontWeight: 600,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Description
                                        sx={{ mr: 1, color: "primary.main" }}
                                      />
                                      Lesson Materials
                                    </Typography>

                                    {lesson.lessonFiles?.length ? (
                                      <>
                                        <Grid
                                          container
                                          spacing={2}
                                          sx={{ mb: 3 }}
                                        >
                                          {lesson.lessonFiles.map((file) => (
                                            <Grid
                                              item
                                              xs={12}
                                              sm={6}
                                              md={4}
                                              key={file.id}
                                            >
                                              <Paper
                                                elevation={0}
                                                sx={{
                                                  p: 2,
                                                  border: `1px solid ${theme.palette.divider}`,
                                                  borderRadius: 2,
                                                  transition: "all 0.2s ease",
                                                  "&:hover": {
                                                    borderColor: "primary.main",
                                                    transform:
                                                      "translateY(-2px)",
                                                  },
                                                }}
                                              >
                                                <Stack
                                                  direction="row"
                                                  alignItems="center"
                                                  spacing={2}
                                                >
                                                  <Avatar
                                                    sx={{
                                                      background:
                                                        "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
                                                      width: 32,
                                                      height: 32,
                                                    }}
                                                  >
                                                    <Description fontSize="small" />
                                                  </Avatar>
                                                  <Box
                                                    sx={{
                                                      flex: 1,
                                                      minWidth: 0,
                                                    }}
                                                  >
                                                    <Typography
                                                      variant="body2"
                                                      sx={{
                                                        fontWeight: 600,
                                                        overflow: "hidden",
                                                        textOverflow:
                                                          "ellipsis",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <a
                                                        href={file.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                          color:
                                                            theme.palette
                                                              .primary.main,
                                                          textDecoration:
                                                            "none",
                                                        }}
                                                      >
                                                        {file.name}
                                                      </a>
                                                    </Typography>
                                                    {file.activityType && (
                                                      <Chip
                                                        label={
                                                          file.activityType
                                                        }
                                                        size="small"
                                                        sx={{
                                                          mt: 0.5,
                                                          fontSize: "0.7rem",
                                                        }}
                                                      />
                                                    )}
                                                  </Box>
                                                </Stack>
                                              </Paper>
                                            </Grid>
                                          ))}
                                        </Grid>

                                        <Divider sx={{ my: 3 }} />

                                        {/* ✅ CBT Assessment Section */}
                                        <Box>
                                          <Typography
                                            variant="h6"
                                            sx={{
                                              mb: 2,
                                              fontWeight: 600,
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Quiz
                                              sx={{
                                                mr: 1,
                                                color: "secondary.main",
                                              }}
                                            />
                                            CBT Assessment
                                          </Typography>

                                          {lesson.quizzes?.length > 0 ? (
                                            <Paper
                                              elevation={0}
                                              sx={{
                                                p: 3,
                                                border: `1px solid ${theme.palette.divider}`,
                                                borderRadius: 3,
                                                background:
                                                  theme.palette.mode === "dark"
                                                    ? "rgba(255,255,255,0.02)"
                                                    : "rgba(0,0,0,0.02)",
                                              }}
                                            >
                                              <Stack
                                                direction="row"
                                                alignItems="center"
                                                justifyContent="space-between"
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <Avatar
                                                    sx={{
                                                      background:
                                                        "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
                                                      mr: 2,
                                                    }}
                                                  >
                                                    <Assessment />
                                                  </Avatar>
                                                  <Box>
                                                    <Typography
                                                      variant="h6"
                                                      sx={{ fontWeight: 600 }}
                                                    >
                                                      {lesson.quizzes[0].name}
                                                    </Typography>
                                                    <Typography
                                                      variant="body2"
                                                      color="text.secondary"
                                                    >
                                                      Interactive assessment
                                                      ready
                                                    </Typography>
                                                  </Box>
                                                </Box>
                                                <Stack
                                                  direction="row"
                                                  spacing={1}
                                                >
                                                  <Button
                                                    variant="contained"
                                                    size="small"
                                                    startIcon={<Add />}
                                                    onClick={() =>
                                                      handleShowQuestion(
                                                        lesson.lessonID
                                                      )
                                                    }
                                                    sx={{
                                                      background:
                                                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                                      borderRadius: 2,
                                                    }}
                                                  >
                                                    Add Questions
                                                  </Button>
                                                  <Button
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={<Assessment />}
                                                    onClick={() =>
                                                      handleShowQuestion(
                                                        lesson.lessonID
                                                      )
                                                    }
                                                    sx={{ borderRadius: 2 }}
                                                  >
                                                    View Questions
                                                  </Button>
                                                </Stack>
                                              </Stack>
                                            </Paper>
                                          ) : (
                                            <Paper
                                              elevation={0}
                                              sx={{
                                                p: 3,
                                                border: `1px dashed ${theme.palette.divider}`,
                                                borderRadius: 3,
                                                textAlign: "center",
                                              }}
                                            >
                                              <Quiz
                                                sx={{
                                                  fontSize: 48,
                                                  color: "text.secondary",
                                                  mb: 2,
                                                }}
                                              />
                                              <Typography
                                                variant="body1"
                                                color="text.secondary"
                                                sx={{ mb: 2 }}
                                              >
                                                No CBT assessment available
                                              </Typography>
                                              <Button
                                                variant="contained"
                                                startIcon={<Add />}
                                                onClick={() =>
                                                  handleShowTitle(
                                                    lesson.lessonID
                                                  )
                                                }
                                                sx={{
                                                  background:
                                                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                                  borderRadius: 3,
                                                }}
                                              >
                                                Create CBT Assessment
                                              </Button>
                                            </Paper>
                                          )}
                                        </Box>
                                      </>
                                    ) : (
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        No lesson files available
                                      </Typography>
                                    )}
                                  </Box>
                                </Collapse>
                              </Paper>
                            ))}
                          </Stack>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>

              {/* Pagination controls at bottom */}
              {totalPages > 1 && (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={(event, value) => setCurrentPage(value)}
                    color="primary"
                    size="large"
                    showFirstButton
                    showLastButton
                    sx={{
                      "& .MuiPaginationItem-root": {
                        borderRadius: 2,
                        fontWeight: 600,
                      },
                    }}
                  />
                </Box>
              )}
            </>
          )}

          <Zoom in={courseData[0]?.sections?.length > 0}>
            <Fab
              color="primary"
              onClick={handleAddModule}
              disabled={isLoading}
              sx={{
                position: "fixed",
                bottom: 24,
                right: 24,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)",
                },
              }}
            >
              <Add />
            </Fab>
          </Zoom>

          {/* Add Module Modal */}
          <Dialog
            open={showModuleModal}
            onClose={() => {
              setShowModuleModal(false);
              setNewModuleTitle("");
            }}
            fullWidth
            maxWidth="sm"
            PaperProps={{
              sx: {
                borderRadius: 4,
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(135deg, #2d3748 0%, #4a5568 100%)"
                    : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
              },
            }}
          >
            <DialogTitle sx={{ pb: 1 }}>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, display: "flex", alignItems: "center" }}
              >
                <BookmarkBorder sx={{ mr: 1, color: "primary.main" }} />
                Add New Module
              </Typography>
            </DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Module Title"
                value={newModuleTitle}
                onChange={(e) => setNewModuleTitle(e.target.value)}
                variant="outlined"
                margin="normal"
                error={status.error && !newModuleTitle.trim()}
                helperText={
                  status.error && !newModuleTitle.trim()
                    ? "Module title is required"
                    : ""
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 3,
                  },
                }}
              />
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 1 }}>
              <Button
                onClick={() => {
                  setShowModuleModal(false);
                  setNewModuleTitle("");
                }}
                sx={{ borderRadius: 3 }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleAddOrEditModule}
                disabled={isLoading || !newModuleTitle.trim()}
                variant="contained"
                sx={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: 3,
                  px: 3,
                }}
              >
                {isLoading ? "Adding..." : "Add Module"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Add Lesson Modal */}
          <Dialog
            open={!!showLessonTitleModal}
            onClose={() => {
              setShowLessonTitleModal(null);
              setNewLessonTitle("");
            }}
            fullWidth
            maxWidth="sm"
            PaperProps={{
              sx: {
                borderRadius: 4,
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(135deg, #2d3748 0%, #4a5568 100%)"
                    : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
              },
            }}
          >
            <DialogTitle sx={{ pb: 1 }}>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, display: "flex", alignItems: "center" }}
              >
                <PlayCircleOutline sx={{ mr: 1, color: "primary.main" }} />
                Add New Lesson
              </Typography>
            </DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Lesson Title"
                value={newLessonTitle}
                onChange={(e) => setNewLessonTitle(e.target.value)}
                variant="outlined"
                margin="normal"
                error={status.error && !newLessonTitle.trim()}
                helperText={
                  status.error && !newLessonTitle.trim()
                    ? "Lesson title is required"
                    : ""
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 3,
                  },
                }}
              />
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 1 }}>
              <Button
                onClick={() => {
                  setShowLessonTitleModal(null);
                  setNewLessonTitle("");
                }}
                sx={{ borderRadius: 3 }}
              >
                Cancel
              </Button>
              <Button
                onClick={() =>
                  showLessonTitleModal &&
                  handleAddOrEditLessonTitle(showLessonTitleModal)
                }
                disabled={isLoading || !newLessonTitle.trim()}
                variant="contained"
                sx={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: 3,
                  px: 3,
                }}
              >
                {isLoading ? "Adding..." : "Add Lesson"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Add File Modal */}
          <Dialog
            open={!!showLessonFileModal}
            onClose={() => {
              setShowLessonFileModal(null);
              setNewFileTitle("");
              setNewFileMediaLink("");
              setNewFileMediaType("link");
              setFileUpload(null);
              setActivityCompletion(0);
              setCompletionConstraint(0);
              setSelectedFileId("0");
            }}
            fullWidth
            maxWidth="sm"
            PaperProps={{
              sx: {
                borderRadius: 4,
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(135deg, #2d3748 0%, #4a5568 100%)"
                    : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
              },
            }}
          >
            <DialogTitle sx={{ pb: 1 }}>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, display: "flex", alignItems: "center" }}
              >
                <Description sx={{ mr: 1, color: "primary.main" }} />
                Add Lesson File
              </Typography>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={2} style={{ marginTop: "8px" }}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="File Title"
                    value={newFileTitle}
                    onChange={(e) => setNewFileTitle(e.target.value)}
                    variant="outlined"
                    error={status.error && !newFileTitle.trim()}
                    helperText={
                      status.error && !newFileTitle.trim()
                        ? "File title is required"
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 3,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      value={mediaType}
                      onChange={(e) =>
                        setMediaType(e.target.value as "file" | "link")
                      }
                    >
                      <FormControlLabel
                        value="file"
                        control={<Radio />}
                        label="Upload File"
                      />
                      <FormControlLabel
                        value="link"
                        control={<Radio />}
                        label="External Link"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                {mediaType === "file" ? (
                  <Grid item xs={12}>
                    <input
                      // accept=".pdf,.doc,.docx,.ppt,.pptx"
                      style={{ display: "none" }}
                      id="lesson-file-upload"
                      type="file"
                      onChange={handleFileChange}
                    />
                    <label htmlFor="lesson-file-upload">
                      <Button
                        variant="outlined"
                        component="span"
                        startIcon={<CloudUploadIcon />}
                        fullWidth
                        sx={{
                          borderRadius: 3,
                          py: 2,
                          borderStyle: "dashed",
                        }}
                      >
                        Upload Document
                      </Button>
                    </label>
                    {fileUpload && (
                      <Alert severity="success" sx={{ mt: 2, borderRadius: 2 }}>
                        Selected file: {fileUpload.name}
                      </Alert>
                    )}
                    {status.error && mediaType === "file" && !fileUpload && (
                      <Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>
                        Please upload a file
                      </Alert>
                    )}
                  </Grid>
                ) : (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Media Link"
                      value={newFileMediaLink}
                      onChange={handleLinkChange}
                      variant="outlined"
                      error={status.error && !newFileMediaLink.trim()}
                      helperText={
                        status.error && !newFileMediaLink.trim()
                          ? "Media link is required"
                          : ""
                      }
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 3,
                        },
                      }}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Select Lesson File</InputLabel>
                    <Select
                      value={selectedFileId}
                      onChange={handleChange}
                      input={<OutlinedInput label="Select Lesson File" />}
                      renderValue={(selected) => {
                        if (selected === "0") return "None";
                        const file = selectedItems
                          .flatMap((s) => s.lessonFiles)
                          .find((f) => f.activityID === selected);
                        return file ? file.name : "None";
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 300,
                            borderRadius: 12,
                          },
                        },
                      }}
                      sx={{
                        borderRadius: 3,
                      }}
                    >
                      <MenuItem value="0">
                        <Radio checked={selectedFileId === "0"} />
                        None
                      </MenuItem>
                      {selectedItems.flatMap((section) => [
                        <ListSubheader key={`header-${section.section.secID}`}>
                          {section.section.name}
                        </ListSubheader>,
                        ...(section.lessonFiles.length > 0
                          ? section.lessonFiles.map((file) => (
                              <MenuItem
                                key={file.activityID}
                                value={file.activityID}
                              >
                                <Radio
                                  checked={selectedFileId === file.activityID}
                                />
                                {file.name}
                              </MenuItem>
                            ))
                          : [
                              <MenuItem
                                key={`no-files-${section.section.secID}`}
                                disabled
                                sx={{ pl: 4, fontStyle: "italic" }}
                              >
                                No files
                              </MenuItem>,
                            ]),
                      ])}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Completion Constraint</InputLabel>
                    <Select
                      value={completionConstraint}
                      onChange={(e) =>
                        setCompletionConstraint(Number(e.target.value))
                      }
                      label="Completion Constraint"
                      sx={{ borderRadius: 3 }}
                    >
                      <MenuItem value={0}>None</MenuItem>
                      <MenuItem value={1}>Marked Completed</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 1 }}>
              <Button
                onClick={() => {
                  setShowLessonFileModal(null);
                  setNewFileTitle("");
                  setNewFileMediaLink("");
                  setNewFileMediaType("link");
                  setFileUpload(null);
                  setActivityCompletion(0);
                  setCompletionConstraint(0);
                  setSelectedFileId("0");
                }}
                sx={{ borderRadius: 3 }}
              >
                Cancel
              </Button>
              <Button
                onClick={() =>
                  showLessonFileModal &&
                  handleAddOrEditLessonFile(showLessonFileModal)
                }
                disabled={
                  isLoading ||
                  !newFileTitle.trim() ||
                  (mediaType === "file" && !fileUpload) ||
                  (mediaType === "link" && !newFileMediaLink.trim())
                }
                variant="contained"
                sx={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: 3,
                  px: 3,
                }}
              >
                {isLoading ? "Adding..." : "Add File"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Add CBT Test Modal */}
          <Dialog
            open={!!showCBTTitleModal}
            onClose={() => {
              setShowCBTTitleModal(null);
              setNewCBTTitle("");
              setPassGrade("");
              setFailRemark("");
              setPassRemark("");
              setQuestionGrade("");
              setQuizTime("");
              setUnlimitedExam("0");
              setCbtConstraint("0");
              setQuizType("lesson");
              setSelectedFileId("0");
            }}
            fullWidth
            maxWidth="md"
            PaperProps={{
              sx: {
                borderRadius: 4,
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(135deg, #2d3748 0%, #4a5568 100%)"
                    : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
              },
            }}
          >
            <DialogTitle sx={{ pb: 1 }}>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, display: "flex", alignItems: "center" }}
              >
                <Quiz sx={{ mr: 1, color: "secondary.main" }} />
                Add CBT Assessment
              </Typography>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={3} style={{ marginTop: "8px" }}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="CBT Title"
                    value={newCBTTitle}
                    onChange={(e) => setNewCBTTitle(e.target.value)}
                    variant="outlined"
                    error={status.error && !newCBTTitle.trim()}
                    helperText={
                      status.error && !newCBTTitle.trim()
                        ? "CBT title is required"
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 3,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Passing Grade"
                    type="number"
                    value={passGrade}
                    onChange={(e) => setPassGrade(e.target.value)}
                    variant="outlined"
                    error={
                      status.error &&
                      (!passGrade.trim() ||
                        isNaN(Number(passGrade)) ||
                        Number(passGrade) < 0 ||
                        Number(passGrade) > 100)
                    }
                    helperText={
                      status.error &&
                      (!passGrade.trim() ||
                        isNaN(Number(passGrade)) ||
                        Number(passGrade) < 0 ||
                        Number(passGrade) > 100)
                        ? "Valid passing grade (0-100%) required"
                        : ""
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 3,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Question Grade"
                    type="number"
                    value={questionGrade}
                    onChange={(e) => setQuestionGrade(e.target.value)}
                    variant="outlined"
                    error={
                      status.error &&
                      (!questionGrade.trim() ||
                        isNaN(Number(questionGrade)) ||
                        Number(questionGrade) <= 0)
                    }
                    helperText={
                      status.error &&
                      (!questionGrade.trim() ||
                        isNaN(Number(questionGrade)) ||
                        Number(questionGrade) <= 0)
                        ? "Valid question grade (greater than 0) required"
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 3,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Quiz Time (minutes)"
                    type="number"
                    value={quizTime}
                    onChange={(e) => setQuizTime(e.target.value)}
                    variant="outlined"
                    error={
                      status.error &&
                      (!quizTime.trim() ||
                        isNaN(Number(quizTime)) ||
                        Number(quizTime) <= 0)
                    }
                    helperText={
                      status.error &&
                      (!quizTime.trim() ||
                        isNaN(Number(quizTime)) ||
                        Number(quizTime) <= 0)
                        ? "Valid quiz time (greater than 0) required"
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 3,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Unlimited Exam Attempts</InputLabel>
                    <Select
                      value={unlimitedExam}
                      onChange={(e) => setUnlimitedExam(e.target.value)}
                      label="Unlimited Exam Attempts"
                      sx={{ borderRadius: 3 }}
                    >
                      <MenuItem value="1">Yes</MenuItem>
                      <MenuItem value="0">No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Pass Remark"
                    value={passRemark}
                    onChange={(e) => setPassRemark(e.target.value)}
                    variant="outlined"
                    multiline
                    rows={2}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 3,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Fail Remark"
                    value={failRemark}
                    onChange={(e) => setFailRemark(e.target.value)}
                    variant="outlined"
                    multiline
                    rows={2}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 3,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Quiz Type</InputLabel>
                    <Select
                      value={quizType}
                      onChange={(e) =>
                        setQuizType(e.target.value as "lesson" | "section")
                      }
                      label="Quiz Type"
                      sx={{ borderRadius: 3 }}
                    >
                      <MenuItem value="lesson">Lesson</MenuItem>
                      <MenuItem value="section">Section</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Constraint</InputLabel>
                    <Select
                      value={cbtConstraint}
                      onChange={(e) => setCbtConstraint(e.target.value)}
                      label="Constraint"
                      sx={{ borderRadius: 3 }}
                    >
                      <MenuItem value="0">None</MenuItem>
                      <MenuItem value="1">Mark Completed</MenuItem>
                      <MenuItem value="2">Mark Completed and Passed</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Select Lesson File</InputLabel>
                    <Select
                      value={selectedFileId}
                      onChange={handleChange}
                      input={<OutlinedInput label="Select Lesson File" />}
                      renderValue={(selected) => {
                        if (selected === "0") return "None";
                        const file = selectedItems
                          .flatMap((s) => s.lessonFiles)
                          .find((f) => f.activityID === selected);
                        return file ? file.name : "None";
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 300,
                            borderRadius: 12,
                          },
                        },
                      }}
                      sx={{ borderRadius: 3 }}
                    >
                      <MenuItem value="0">
                        <Radio checked={selectedFileId === "0"} />
                        None
                      </MenuItem>
                      {selectedItems.flatMap((section) => [
                        <ListSubheader key={`header-${section.section.secID}`}>
                          {section.section.name}
                        </ListSubheader>,
                        ...(section.lessonFiles.length > 0
                          ? section.lessonFiles.map((file) => (
                              <MenuItem
                                key={file.activityID}
                                value={file.activityID}
                              >
                                <Radio
                                  checked={selectedFileId === file.activityID}
                                />
                                {file.name}
                              </MenuItem>
                            ))
                          : [
                              <MenuItem
                                key={`no-files-${section.section.secID}`}
                                disabled
                                sx={{ pl: 4, fontStyle: "italic" }}
                              >
                                No files
                              </MenuItem>,
                            ]),
                      ])}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 1 }}>
              <Button
                onClick={() => {
                  setShowCBTTitleModal(null);
                  setNewCBTTitle("");
                  setPassGrade("");
                  setFailRemark("");
                  setPassRemark("");
                  setQuestionGrade("");
                  setQuizTime("");
                  setUnlimitedExam("0");
                  setCbtConstraint("0");
                  setQuizType("lesson");
                  setSelectedFileId("0");
                }}
                sx={{ borderRadius: 3 }}
              >
                Cancel
              </Button>
              <Button
                onClick={() =>
                  showCBTTitleModal && handleAddCBTTitle(showCBTTitleModal)
                }
                disabled={
                  isLoading ||
                  !newCBTTitle.trim() ||
                  !passGrade.trim() ||
                  isNaN(Number(passGrade)) ||
                  Number(passGrade) < 0 ||
                  Number(passGrade) > 100 ||
                  !questionGrade.trim() ||
                  isNaN(Number(questionGrade)) ||
                  Number(questionGrade) <= 0 ||
                  !quizTime.trim() ||
                  isNaN(Number(quizTime)) ||
                  Number(quizTime) <= 0
                }
                variant="contained"
                sx={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: 3,
                  px: 3,
                }}
              >
                {isLoading ? "Adding..." : "Add CBT"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Add/View CBT Questions Modal */}
          <Dialog
            open={!!showCBTQuestionsModal}
            onClose={() => {
              setShowCBTQuestionsModal(null);
              setNewQuestionText("");
              setNewQuestionOptions(["", "", "", "", ""]);
              setNewQuestionCorrectAnswer(0);
              setCBTQuestions([]);
            }}
            fullWidth
            maxWidth="lg"
            PaperProps={{
              sx: {
                borderRadius: 4,
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(135deg, #2d3748 0%, #4a5568 100%)"
                    : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                maxHeight: "90vh",
              },
            }}
          >
            <DialogTitle sx={{ pb: 1 }}>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, display: "flex", alignItems: "center" }}
              >
                <Quiz sx={{ mr: 1, color: "secondary.main" }} />
                CBT Questions Manager
              </Typography>
            </DialogTitle>
            <DialogContent sx={{ pb: 1 }}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  mb: 3,
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 3,
                  background:
                    theme.palette.mode === "dark"
                      ? "rgba(255,255,255,0.02)"
                      : "rgba(0,0,0,0.02)",
                }}
              >
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                  Add New Question
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Question Text"
                      value={newQuestionText}
                      onChange={(e) => setNewQuestionText(e.target.value)}
                      variant="outlined"
                      multiline
                      rows={3}
                      error={status.error && !newQuestionText.trim()}
                      helperText={
                        status.error && !newQuestionText.trim()
                          ? "Question text is required"
                          : ""
                      }
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 3,
                        },
                      }}
                    />
                  </Grid>
                  {[0, 1, 2, 3, 4].map((index) => (
                    <Grid item xs={12} sm={6} key={index}>
                      <TextField
                        fullWidth
                        label={`Option ${String.fromCharCode(65 + index)}`}
                        value={newQuestionOptions[index]}
                        onChange={(e) => {
                          const newOptions = [...newQuestionOptions];
                          newOptions[index] = e.target.value;
                          setNewQuestionOptions(newOptions);
                        }}
                        variant="outlined"
                        error={
                          status.error && !newQuestionOptions[index].trim()
                        }
                        helperText={
                          status.error && !newQuestionOptions[index].trim()
                            ? "Option is required"
                            : ""
                        }
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 3,
                          },
                        }}
                      />
                    </Grid>
                  ))}
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Correct Answer</InputLabel>
                      <Select
                        value={newQuestionCorrectAnswer}
                        onChange={(e) =>
                          setNewQuestionCorrectAnswer(e.target.value)
                        }
                        label="Correct Answer"
                        error={
                          status.error &&
                          (newQuestionCorrectAnswer < 0 ||
                            newQuestionCorrectAnswer >=
                              newQuestionOptions.length ||
                            !newQuestionOptions[
                              newQuestionCorrectAnswer
                            ].trim())
                        }
                        sx={{ borderRadius: 3 }}
                      >
                        {newQuestionOptions.map((option, index) => (
                          <MenuItem
                            key={index}
                            value={option}
                            disabled={!option.trim()}
                          >
                            {String.fromCharCode(65 + index)}:{" "}
                            {option || `Option ${index + 1}`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Button
                      variant="contained"
                      fullWidth
                      size="large"
                      onClick={() =>
                        showCBTQuestionsModal &&
                        handleAddQuestion(showCBTQuestionsModal)
                      }
                      disabled={
                        isLoading ||
                        !newQuestionText.trim() ||
                        newQuestionOptions.some((opt) => !opt.trim())
                      }
                      sx={{
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        borderRadius: 3,
                        py: 1.5,
                      }}
                    >
                      {isLoading ? "Adding..." : "Add Question"}
                    </Button>
                  </Grid>
                </Grid>
              </Paper>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Questions List ({cbtQuestions.length})
              </Typography>

              {cbtQuestions.length > 0 ? (
                <Paper
                  elevation={0}
                  sx={{
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 3,
                    overflow: "hidden",
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow
                        sx={{
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        }}
                      >
                        <TableCell
                          sx={{ fontWeight: 700, color: "white", width: 60 }}
                        >
                          #
                        </TableCell>
                        <TableCell sx={{ fontWeight: 700, color: "white" }}>
                          Question
                        </TableCell>
                        <TableCell sx={{ fontWeight: 700, color: "white" }}>
                          Options
                        </TableCell>
                        <TableCell
                          sx={{ fontWeight: 700, color: "white", width: 120 }}
                        >
                          Correct Answer
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            color: "white",
                            width: 100,
                            textAlign: "center",
                          }}
                        >
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {cbtQuestions.map((question, index) => (
                        <TableRow
                          key={question.id}
                          hover
                          sx={{
                            backgroundColor: (theme) =>
                              theme.palette.mode === "light"
                                ? index % 2 === 0
                                  ? "#f8fafc"
                                  : "white"
                                : index % 2 === 0
                                ? "#1e293b"
                                : "#0f172a",
                            "&:hover": {
                              backgroundColor: (theme) =>
                                theme.palette.mode === "light"
                                  ? "#f1f5f9"
                                  : "#334155",
                            },
                          }}
                        >
                          <TableCell sx={{ fontWeight: 600 }}>
                            <Avatar
                              sx={{
                                width: 32,
                                height: 32,
                                background:
                                  "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                                fontSize: "0.875rem",
                                fontWeight: 700,
                              }}
                            >
                              {index + 1}
                            </Avatar>
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: 600,
                              maxWidth: 300,
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                          >
                            {question.question}
                          </TableCell>
                          <TableCell sx={{ maxWidth: 250 }}>
                            <Stack spacing={1}>
                              {[1, 2, 3, 4, 5].map(
                                (optNum) =>
                                  question[`option${optNum}`] && (
                                    <Box
                                      key={optNum}
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Avatar
                                        sx={{
                                          width: 24,
                                          height: 24,
                                          mr: 1,
                                          fontSize: "0.75rem",
                                          fontWeight: 600,
                                          background:
                                            question.ans === optNum.toString()
                                              ? "linear-gradient(135deg, #4caf50 0%, #45a049 100%)"
                                              : "linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%)",
                                          color:
                                            question.ans === optNum.toString()
                                              ? "white"
                                              : "text.secondary",
                                        }}
                                      >
                                        {String.fromCharCode(64 + optNum)}
                                      </Avatar>
                                      <Typography variant="body2">
                                        {question[`option${optNum}`]}
                                      </Typography>
                                    </Box>
                                  )
                              )}
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={`Option ${question.ans} `}
                              color="success"
                              variant="outlined"
                              sx={{ fontWeight: 600 }}
                            />
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Tooltip title="Edit Question" arrow>
                              <IconButton
                                size="small"
                                sx={{
                                  background:
                                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                  color: "white",
                                  "&:hover": {
                                    background:
                                      "linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)",
                                  },
                                }}
                              >
                                <EditNotifications fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>
              ) : (
                <Paper
                  elevation={0}
                  sx={{
                    p: 6,
                    textAlign: "center",
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 3,
                  }}
                >
                  <Quiz sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
                  <Typography
                    variant="h6"
                    color="text.secondary"
                    sx={{ mb: 1 }}
                  >
                    No questions added yet
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Add your first question using the form above
                  </Typography>
                </Paper>
              )}
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 1 }}>
              <Button
                onClick={() => {
                  setShowCBTQuestionsModal(null);
                  setNewQuestionText("");
                  setNewQuestionOptions(["", "", "", "", ""]);
                  setNewQuestionCorrectAnswer(0);
                  setCBTQuestions([]);
                }}
                variant="contained"
                sx={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: 3,
                  px: 4,
                }}
              >
                Done
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </IonContent>
    </IonPage>
  );
};

export default ModulePage;
